import useSWR, { SWRResponse } from "swr";
import useHttpClient from "../useHttpClient";
import { Loan } from "../../types";

const useLoans = (): SWRResponse<Loan[], Error> => {
  const httpClient = useHttpClient();
  return useSWR(
    "loans",
    (): Promise<Loan[]> =>
      httpClient
        .get("/loans?_sort=id&_order=DESC&_page_size=50")
        .then((res) => res.data.data),
    { revalidateOnFocus: true }
  );
};

export default useLoans;
